import SearchIcon from "@mui/icons-material/Search";
import { IconButton, TextField } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectIsSearchExtended,
  selectIsYardSearchExtended,
  selectIsYardTab,
  selectSearchQuery,
  selectYardSearchQuery,
} from "../../redux/selector";
import { actions } from "../../redux/slice";
import StatusTabs, { YardStatusTabs } from "../StatusTabs";
import { useStyles } from "./styles";

const ActionBar = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const searchQuery = useSelector(selectSearchQuery);
  const yardSearchQuery = useSelector(selectYardSearchQuery);
  const isSearchExtended = useSelector(selectIsSearchExtended);
  const isYardSearchExtended = useSelector(selectIsYardSearchExtended);
  const showYardTabs = useSelector(selectIsYardTab);

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.row}>
        {isSearchExtended ? (
          <TextField
            className={styles.search}
            placeholder={t("PLACEHOLDERS.SEARCH")}
            size="small"
            autoFocus
            value={searchQuery}
            onChange={(event) =>
              dispatch(actions.setSearchQuery(event.target.value))
            }
            onBlur={() => {
              dispatch(actions.setIsSearchExtended(false));
              dispatch(actions.setSearchQuery(""));
            }}
            InputProps={{
              startAdornment: <SearchIcon className={styles.searchIcon} />,
            }}
          />
        ) : (
          <IconButton
            className={styles.searchButton}
            onClick={() =>
              dispatch(actions.setIsSearchExtended(!isSearchExtended))
            }
          >
            <SearchIcon className={styles.searchIcon} />
          </IconButton>
        )}
        <StatusTabs />
      </div>
      {showYardTabs && (
        <div className={styles.yardRow}>
          {isYardSearchExtended ? (
            <TextField
              className={styles.search}
              placeholder={t("PLACEHOLDERS.SEARCH")}
              size="small"
              autoFocus
              value={yardSearchQuery}
              onChange={(event) =>
                dispatch(actions.setYardSearchQuery(event.target.value))
              }
              onBlur={() => {
                dispatch(actions.setIsYardSearchExtended(false));
                dispatch(actions.setYardSearchQuery(""));
              }}
              InputProps={{
                startAdornment: <SearchIcon className={styles.searchIcon} />,
              }}
            />
          ) : (
            <IconButton
              className={styles.searchButton}
              onClick={() =>
                dispatch(
                  actions.setIsYardSearchExtended(!isYardSearchExtended)
                )
              }
            >
              <SearchIcon className={styles.searchIcon} />
            </IconButton>
          )}
          <YardStatusTabs />
        </div>
      )}
    </div>
  );
};

export default ActionBar;

